import { z } from 'zod';

export const loginSchema = z.object({
  phone: z.string().email('Invalid email address'),
  password: z.string().min(6, 'Password must be at least 6 characters'),
});

export const otpLoginSchema = z.object({
  phone: z.string().min(10, 'Phone number must be at least 10 digits'),
});

export const formSchema = z.object({
  email: z.string().email('Invalid email address').optional(),
  region: z.string().min(3, 'Region is required'),
  phone: z.string().min(10, 'Phone number must be at least 10 digits'),
  marketing_consent: z.boolean().optional(),
  whatsapp_same_number: z.boolean().optional(),
});

export const InfoSchema = z.object({
  fullName: z.string().min(1, 'full name is required').optional(),
  dateOfBirth: z.date().max(new Date(), 'Date is required'),
  company: z.string().min(1, 'Company is required').optional(),
  salary: z.string().min(1, 'Salary is required').optional(),
  maritalStatus: z.string().min(1, 'Marital status is required'),
  gender: z.string().min(1, 'Gender is required'),
  digitalAddress: z.string().min(1, 'Digital address is required').optional(),
  employmentStatus: z.string(),//.min(1, 'Employment status is required'),
  occupation: z.string().optional(),//.min(1, 'Occupation is required'),
});

export const EmploymentDetails = z.object({
  employmentStatus: z.string().min(1, 'Employment status is required'),
  occupation: z.string().min(1, 'Occupation is required'),
});

export const OTPFormSchema = z.object({
  pin: z.string().min(6, 'OTP must be 6 digits').max(6, 'OTP must be 6 digits'),
});

export const residencySchema = z.object({
  residentialAddress: z.string().min(1, 'Residential address is required'),
  city: z.string().min(1, 'City is required'),
  region: z.string().min(1, 'Region is required'),
  postalCode: z.string().optional(),
});

export const ecobankPreApprovalSchema = z.object({
  accountNumber: z
    .string()
    .min(10, 'Account number must be at least 10 digits'),
  phoneNumber: z.string().min(10, 'Phone number must be at least 10 digits'),
  amount: z.number().min(1, 'Amount must be greater than 0'),
});

export type LoginInput = z.infer<typeof loginSchema>;
export type OTPLoginInput = z.infer<typeof otpLoginSchema>;
export type FormInput = z.infer<typeof formSchema>;
export type InfoInput = z.infer<typeof InfoSchema>;
export type OTPFormInput = z.infer<typeof OTPFormSchema>;
export type ResidencyInput = z.infer<typeof residencySchema>;
export type EcobankPreApprovalInput = z.infer<typeof ecobankPreApprovalSchema>;
